import BannerAbstract from './BannerAbstract'
import Filters from '../abstracts/Filters'

export default class AlertBanner extends BannerAbstract {
  constructor(parameters, LanguageManager) {
    super(parameters, LanguageManager)

    // config
    this.key = 'alerte'
    this.type = 'alert'
    this.content = this.getContent()
  }

  getHtmlId() {
    return 'rousquilleAlert'
  }

  getContent() {
    // force LanguageManager to initialize its translations before we start using them
    const translations = this.LanguageManager.getTranslations()

    // build banner element markup
    const htmlId = this.getHtmlId()
    let html = ''
    html += `  <div id="${htmlId}Wrapper" class="rsq-overlay"></div>`
    html += '  <div class="inner">'
    html += `    <div class="deny-link-wrapper"><a class="link action btnAll denyAll deny" href="#">${this.LanguageManager.translations.denyAll}</a></div>`
    html += '    <div class="info">'
    html += `      <strong class="h1">${translations.alertDisclaimerTitle}</strong>`
    html += `      <div class="disclaimer-text">${translations.alertDisclaimerText}</div>`
    html += '    </div>'
    html += '    <div class="actions">'
    html += `      <button class="btn btnAll allowAll allow">${translations.accept}</button>`
    html += `      <a class="btn btn-outline action openPanel" href="#">${translations.personalize}</a>`
    html += '    </div>'
    html += '  </div>'

    // pass built markup to a dom element, so that we can easily filter it
    let alertBannerEl = document.createElement('div')
    alertBannerEl.id = htmlId
    alertBannerEl.classList.add('alert', this.parameters.orientation)
    alertBannerEl.innerHTML = html

    // allow external components to filter banner element before display
    alertBannerEl = Filters.applyFilters('banners.alert.domElement', alertBannerEl)

    return alertBannerEl.outerHTML
  }
}
